module.exports = __webpack_public_path__ + "static/img/slide3.d0d35a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/original-slides/slide3.jpg
// module id = O4rL
// module chunks = 1